export function stripHtmlTags(input: string | null | undefined): string {
    if (!input) return ""; // Handle null, undefined, and empty strings

    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');
    return doc.body.textContent ?? "";
}
